import React,{useState} from "react";
import "./CertificateSection.css"; // Import your CSS file here
import CustomModal from "./CustomModal";

const CertificateSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
    const openModal = () => {
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
    };
  return (
    <><div className="certification-container">
      <h2 className="titlee">Become A Certified Digital Marketing Professional Today</h2>
      <p className="subtitle">
        After completing this course, you will receive a Digital Marketing Certification from
        <strong> Arrow Digital</strong>. This certification is designed to help students showcase their
        skills and stand out in the competitive job market. Whether you're applying for your first job
        or building your freelance portfolio, this certificate adds immense credibility to your profile.
      </p>
      <div className="certificate-wrapper">
        <img
          src="/certi.png"
          alt="Digital Marketing Certificate"
          className="certificate-image" />
      </div>
      <p className="cta-text">
        Start your career in Digital Marketing with the right guidance and a 100% Job-Gaurantee path!
      </p>
      <button className="cta-button" onClick={openModal}>ENROLL NOW</button>

    </div><CustomModal isOpen={isModalOpen} onClose={closeModal} /></>
  );
};

export default CertificateSection;
